/**
 * ProfileSubPage.jsx — thin wrapper that gives every Profile sub-page
 * the same header treatment: back-arrow, title, optional right-side
 * action slot. Created Feb 26 2026 for the Profile restructure (user
 * asked to "add buttons that lead to their own pages" so the main
 * Profile stays short and scannable).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ProfileSubPage = ({ title, icon: Icon, accent = 'indigo', children, right }) => {
  const navigate = useNavigate();
  return (
    <main className="max-w-4xl mx-auto px-4 py-6" data-testid={`profile-sub-${title?.toLowerCase().replace(/\s+/g, '-')}`}>
      <header className="flex items-center gap-3 mb-5">
        <button
          type="button"
          onClick={() => navigate('/profile')}
          className="p-2 -ml-2 rounded-lg hover:bg-slate-700/50 transition-colors"
          aria-label="Back to Profile"
          data-testid="profile-sub-back"
        >
          <ArrowLeft className="w-5 h-5 text-slate-200" />
        </button>
        <h1 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2 flex-1 min-w-0">
          {Icon && <Icon className={`w-5 h-5 text-${accent}-400 flex-shrink-0`} />}
          <span className="truncate">{title}</span>
        </h1>
        {right}
      </header>
      <div className="space-y-6">{children}</div>
    </main>
  );
};

export default ProfileSubPage;
